export default __webpack_public_path__ + "static/media/greeting2.4979dcc0.svg";